export const HOME = '/';
export const SIGN_IN = '/sign-in';
export const SIGN_UP = '/sign-up';
export const SIGN_UP_CONFIRM = '/sign-up/confirm';
export const SIGN_UP_RESULT = '/sign-up/result';
export const LOG_OUT = '/logout';
export const DASHBOARD = '/dashboard';
export const JUDGMENT = '/judgment';
export const UNFINISHED_ACTION_LIST = '/unfinished-action-list';
export const MACHINE_MASTER = '/machine-master';
export const CHANGE_PASSWORD = '/change-password'

export const SETTING = '/settings';
export const MY_PAGE = '/my-page';
export const MASTER_DASHBOARD = '/master/dashboard'

export const USERS_DASHBOARD = '/users/dashboard';
export const USER_MASTER_UPDATE = '/users/update';
export const USER_MASTER_IMPORT = '/users/import';
export const USER_MASTER_EXPORT = '/users/export';
export const USER_MASTER_SEARCH = '/users/search';
export const USER_MASTER_HISTORY_SEARCH = '/users/history-search';

//Settings
export const APP_SETTING = '/app-settings';
export const TREATMENT = '/treatment';

// Machine Master
export const MACHINE_MASTER_DASHBOARD = '/machines/dashboard';
export const MACHINE_MASTER_UPDATE = '/machines/update';
export const MACHINE_MASTER_HISTORY_SEARCH = '/machines/history-search';
export const MACHINE_MASTER_IMPORT = '/machines/import';
export const MACHINE_MASTER_EXPORT = '/machines/export';
export const MACHINE_MASTER_GROUP_UPDATE = '/machines/group-update';

// Position Master
export const POSITION_MASTER_DASHBOARD = "/positions/dashboard"
export const POSITION_MASTER_UPDATE = '/positions/update';
export const POSITION_MASTER_IMPORT = '/positions/import';
export const POSITION_MASTER_EXPORT = '/positions/export';
export const POSITION_MASTER_HISTORY_SEARCH = '/positions/history-search';

// Department Mater
export const DEPARTMENT_MASTER_DASHBOARD = "/departments/dashboard"
export const DEPARTMENT_MASTER_UPDATE = "/departments/update"
export const DEPARTMENT_MASTER_HISTORY_SEARCH = "/departments/history-search"
export const DEPARTMENT_MASTER_IMPORT = "/departments/import"
export const DEPARTMENT_MASTER_EXPORT = "/departments/export"

// Approval Setting Master
export const APPROVAL_SETTING_MASTER_DASHBOARD = '/approval-settings/dashboard';
export const APPROVAL_SETTING = '/approval-settings';
export const APPROVAL_SETTING_DETAIL = '/approval-settings/:workFollowId';
export const APPROVAL_SETTING_MASTER_SEARCH = '/approval-settings/update-history-search';
export const APPROVAL_SETTING_MASTER_IMPORT = '/approval-settings/import';
export const APPROVAL_SETTING_MASTER_EXPORT = '/approval-settings/export';

// Inspection Template Master
export const INSPECTION_TEMPLATE_MASTER_DASHBOARD = '/inspection-template/dashboard';
export const TEMPLATE_MANAGEMENT = '/template-management';
export const EDIT_INSPECTION_ITEM = '/edit-inspection-item/:id';
export const INSPECTION_TEMPLATE_MASTER_SEARCH = '/inspection-template/update-history-search';
export const INSPECTION_TEMPLATE_MASTER_IMPORT = '/inspection-template/import';
export const INSPECTION_TEMPLATE_MASTER_EXPORT = '/inspection-template/export';

// Inspection
export const MACHINE_INPUT = '/inspections/machine-input';
export const INSPECTION_STATUS = "/inspections/status";
export const INSPECTION_SHEET = "/inspections/sheet";
export const REGISTER_INSPECTION = '/inspections/register/:templateId/:machineId';
export const UPDATE_INSPECTION = '/inspections/update/:inspectionId';

// Treatment
export const REGISTER_TREATMENT = '/treatments/register/:inspectionId';

//Search
export const SEARCH = '/search';
export const SEARCH_MACHINES = '/search/machines'
export const SEARCH_INSPECTION_HISTORY_RESULT = '/search/inspections';
export const SEARCH_TREATMENT_HISTORY_DETAIL = '/search/treatments/detail/:workflow_id/:treatment_id';
export const SEARCH_INSPECTION_HISTORY_CONFIRM = '/search/inspections/confirmation/:workflowId/:inspectionId';
export const SEARCH_INSPECTION_HISTORY_CORRECTION = '/search/inspections/correction/:workflowId/:inspectionId';

export const FFMPEG_CORE_LIBS = '/ffmpeg-core/:filename';